import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBase } from 'src/app/_models/form-base';
import { IconNames } from '../../icons/icon-names';
import { ERROR_MESSAGE } from 'src/app/_helpers/utils';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-graph-checkbox-group',
    templateUrl: './graph-checkbox-group.component.html',
    styleUrls: ['./graph-checkbox-group.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatIcon],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GraphCheckboxGroupComponent {
  title: 'Checkbox';
  component: '';
  tickIconName = IconNames.Tick;
  /** Checkbox base field (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Graph ID (required)*/
  graphId = input<string>();

  /** Array group name (required) */
  formArrayGroupName = input<string>();

  /** Array of checkbox titles (required) */
  checkboxTitles = input<string[]>([]);

  /** Tick icon for checked state (optional, default: Tick) */
  iconName = input<IconNames>(IconNames.Tick);

  /** Set whether checkboxes are disabled (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** Emitted when a checkbox is clicked */
  checkboxClicked = output<Event>();

  updateValue(event: Event): void {
    this.checkboxClicked.emit(event);
  }

  initialiseCheckboxes(index: number): boolean {
    const controlAccessor = this.formArrayGroupName()?.toString();
    const arrayKey = 'controls';
    if (
      controlAccessor &&
      this.parentForm()?.controls?.[controlAccessor]?.[arrayKey]?.[index]
        ?.value === true
    ) {
      return true;
    }
    return null;
  }

  public get hasErrors(): boolean {
    return (
      !!this.parentForm()?.controls?.[this.field().key] &&
      !!this.parentForm()?.controls?.[this.field().key]?.errors &&
      !!this.parentForm()?.controls?.[this.field().key]?.touched
    );
  }

  public get errorsList(): string[] {
    const errors =
      this.parentForm()?.controls?.[this.field().key]?.errors ?? {};
    return Object.keys(errors).map((err) =>
      ERROR_MESSAGE[err](
        this.parentForm()?.controls?.[this.field().key]?.getError(err),
      ) as string,
    );
  }
}
